export const TITLES: string[] = [
  "M.D.", "D.O.", "PA-C", "ARNP", "R.N.", "N.P.", "P.A.", "L.Ac", "DNP", "CWS", "CWSP", "WOCN", "PhD,LMFT", "LMFT", "LMHC", "LCMHC", "APN", "LCSW",
  "PschynNP", "PsyD", "FNP", "NP-C", "FNP-C", "PMHNP", "Admin", "EMT", "AGACNP-BC","PhD","LCPC","APRN-CNP"
];